import { createUsePermissions } from "./createUsePermissions";

export const useBlocksPermissions = createUsePermissions("pb.block");
